import React, { useState, useEffect } from "react";
import { Form, Input, Button, Checkbox, Typography, message, Modal } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import "./styles/Login.css";
import { BASE_URL } from "./config";
const { Title } = Typography;

function Login() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [loading, setLoading] = useState(false);
  const [company, setCompany] = useState(null);
  const [forgotVisible, setForgotVisible] = useState(false);
  const [forgotEmail, setForgotEmail] = useState("");

  useEffect(() => {
    if (!id) return;

    fetch(`${BASE_URL}/get_company.php?id=${id}`)
      .then((res) => res.json())
      .then((data) => {
        if (data.success && data.data) {
          const { company_name, logo } = data.data;
          setCompany({ company_name, logo });
        } else {
          message.error("Company not found");
        }
      })
      .catch(() => message.error("Error fetching company data"));
  }, [id]);

  const onFinish = async (values) => {
    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/api_login.php`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(values),
      });
      const data = await res.json();
      console.log("Login response:", data);
      if (data.success) {
         const userData = {
          username: data.username,
          email: data.email,
          role: data.role,
          company_name: data.company_name,
          company_id: data.company_id,
          company_website: data.company_website,
          phone: data.phone,
          country: data.country,
          logo: data.logo,
          valid_from: data.valid_from,
          valid_to: data.valid_to,
        };

        localStorage.setItem("user", JSON.stringify(userData));

        message.success("Login successful!");
        navigate("/dashboard");
      } else {
        message.error(data.message);
      }
    } catch {
      message.error("Something went wrong");
    }
    setLoading(false);
  };

  // Forgot password logic
// Add two new states
const [showResetField, setShowResetField] = useState(false);
const [resetPassword, setResetPassword] = useState("");

// Forgot password logic (Step 1: send random password)
const handleForgotPassword = async () => {
  if (!forgotEmail) {
    message.error("Please enter your registered email");
    return;
  }

  try {
    const res = await fetch(`${BASE_URL}/forgot_password.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: forgotEmail }),
    });

    const data = await res.json();
    console.log("Forgot password response:", data);

    if (data.success) {
      message.success("A temporary password has been sent to your email");
      setShowResetField(true); // Now show the password reset field
    } else {
      message.error(data.message);
    }
  } catch (error) {
    console.error("Error in forgot password:", error);
    message.error("Something went wrong");
  }
};

// Step 2: user enters new password (the one received on email)
const handleResetPassword = async () => {
  if (!forgotEmail || !resetPassword) {
    message.error("Please fill all fields");
    return;
  }

  try {
    const res = await fetch(`${BASE_URL}/reset_password.php`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email: forgotEmail,
        new_password: resetPassword,
      }),
    });

    const data = await res.json();
    console.log("Reset password response:", data);

    if (data.success) {
      message.success("Password reset successfully! You can now log in.");
      setForgotVisible(false);
      setShowResetField(false);
      setForgotEmail("");
      setResetPassword("");
    } else {
      message.error(data.message);
    }
  } catch (error) {
    console.error("Error in reset password:", error);
    message.error("Error resetting password");
  }
};


  return (
    <div className="login-page">
      <div className="top-bar">
        <img
          src={require("./assets/meet.png")}
          alt="Company Logo"
          className="logo"
        />
        {company?.company_name && (
          <span className="company-name">{company.company_name}</span>
        )}
      </div>

      <div className="login-container">
        <div className="card">
          {/* Left Features */}
          <div className="features-section">
             <Title level={3} className="features-h1">
              Create Your Account Free
            </Title>

            <Title level={3} className="features-title">
              Features of Meeting Fix
            </Title>

            <ul className="features-list">
              <li>☑ SaaS (software as a service) solution</li>
              <li>☑ Schedule your appointment & meetings</li>
              <li>☑ Connect with website and mobile apps</li>
              <li>☑ Add video Conferencing</li>
              <li>☑ Customise your booking page</li>
              <li>☑ Automatically find the best time for your routines</li>
              <li>☑ Protect personal time for meals and travel</li>
              <li>☑ Unlimited meetings using Meeting Fix links</li>
              <li>☑ Integrate with Zoom, Google Meet, Teams, and more</li>
            </ul>

            <Button className="read-more-btn">
              <a
                href="https://meetingfix.com"
                target="_blank"
                rel="noopener noreferrer"
              >
                Read More..
              </a>
            </Button>

            <div className="footer-links">
              <a
                href="https://meetingfix.com/contact_us.php"
                target="_blank"
                rel="noopener noreferrer"
              >
                Contact us
              </a>{" "}
              |{" "}
              <a
                href="https://meetingfix.com/legal/privacy_policy.php"
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
              <br />
              © Foster Digital Technology Pvt Ltd.
            </div>
          </div>

          {/* Right Login */}
          <div className="login-section">
          <div
  style={{
     display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    borderBottom: "2px solid #000", // full underline
    paddingBottom: "6px",
    marginBottom: "16px",
    position: "relative",
  }}
>
  <div style={{ width: "50px" }}></div>
  <Title level={3} className="signin-title" style={{ margin: 0 }}>
    LogIn
  </Title>

<a
  style={{
    cursor: "pointer",
    color: "#1890ff",
    fontSize: "16px",
    textDecoration: "none",
    fontWeight: 500,
  }}
  onClick={() => navigate("/signup")}  // ✅ navigate to signup page
>
  Sign Up
</a>
</div>

         

            <Form layout="vertical" onFinish={onFinish}>
              <Form.Item
                label="USERNAME"
                name="email"
                rules={[{ required: true, message: "Please enter your username!" }]}
              >
                <Input placeholder="Enter Your User Name" />
              </Form.Item>

              <Form.Item
                label="PASSWORD"
                name="password"
                rules={[{ required: true, message: "Please enter your password!" }]}
              >
                <Input.Password placeholder="Enter Your Password" />
              </Form.Item>

              <Form.Item name="remember" valuePropName="checked" initialValue={true}>
                <Checkbox>Keep me Signed in</Checkbox>
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  block
                  className="signin-btn"
                >
                  Sign In
                </Button>
                
              </Form.Item>

              <div style={{ textAlign: "right" }}>
                <a
                  style={{ cursor: "pointer", color: "#1890ff" }}
                  onClick={() => setForgotVisible(true)}
                >
                  Forgot Password?
                </a>
              </div>
               <div style={{ textAlign: "center" }}>
                <a
  style={{
   
  }}
  onClick={() => navigate("/signup")}  // ✅ navigate to signup page
>
  Create an Account
  <p>(Signup for free)</p>
</a>
              </div>
            </Form>
          </div>
        </div>
      </div>

      {/* Forgot Password Modal */}
     <Modal
  title="Forgot Password"
  open={forgotVisible}
  onCancel={() => {
    setForgotVisible(false);
    setShowResetField(false);
  }}
  footer={null}
>
  {/* Step 1: Enter Email */}
  <Input
    placeholder="Enter your registered email"
    value={forgotEmail}
    onChange={(e) => setForgotEmail(e.target.value)}
    disabled={showResetField} // Disable email when next step starts
  />

  {/* Step 2: Enter Password (only after email is verified and code sent) */}
  {showResetField && (
    <Input.Password
      placeholder="Enter the password sent to your email"
      value={resetPassword}
      onChange={(e) => setResetPassword(e.target.value)}
      style={{ marginTop: 12 }}
    />
  )}

  <Button
    type="primary"
    block
    style={{ marginTop: 12 }}
    onClick={showResetField ? handleResetPassword : handleForgotPassword}
  >
    {showResetField ? "Reset Password" : "Send Temporary Password"}
  </Button>
</Modal>

    </div>
  );
}

export default Login;
